var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-editor',{attrs:{"rows":_vm.rows,"disabled":_vm.disabled},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }